import type { VisualizationType } from '@tempo-io/roadmap-dto';

export type VisualizationUrlSegment = 'swimlane' | 'roadmap' | 'table' | 'node-graph';

export function visualizationTypeToUrlSegment(type: VisualizationType): VisualizationUrlSegment {
  if (type === 'nodeGraph') return 'node-graph';
  if (type === 'timeline') return 'roadmap';
  return type;
}

// 'timeline' is the pre-rename segment; old links must still resolve to the Roadmap visualization.
const VISUALIZATION_TYPE_BY_URL_SEGMENT: Record<
  VisualizationUrlSegment | 'timeline',
  VisualizationType
> = {
  swimlane: 'swimlane',
  roadmap: 'timeline',
  timeline: 'timeline',
  table: 'table',
  'node-graph': 'nodeGraph',
};

export function urlSegmentToVisualizationType(segment: string): VisualizationType | undefined {
  return VISUALIZATION_TYPE_BY_URL_SEGMENT[
    segment as keyof typeof VISUALIZATION_TYPE_BY_URL_SEGMENT
  ];
}
